export default "__VITE_ASSET__wNVmn5on__"